import React, { useState, useEffect, ChangeEvent, useCallback } from 'react';
import { Link } from 'gatsby';
import Button from '../../Button';
import useCalculatorSectionData from './dataQuery';
import { Container } from './styles';
import { SharpImage } from '../../../interfaces/SharpImage';
import { BgImage } from '../InfoSection/styles';

interface CalculatorProps {
  title: string;
  subtitle: string;
  buttonText: string;
  mobileText: string;
  image: SharpImage;
}

const CalculatorSectionComponent: React.FC = () => {
  const data: CalculatorProps = useCalculatorSectionData();
  const [costSaved, setCostSaved] = useState('0');
  const [values, setValues] = useState({
    cinema: 6,
    cinemaPerCent: '30%',
    gym: 200,
    gymPerCent: '10%',
    courses: 500,
    coursesPerCent: '10%',
    pharma: 150,
    pharmaPerCent: '8%',
    travel: 200,
    travelPerCent: '4%',
    restaurant: 500,
    restaurantPerCent: '25%',
  });

  useEffect(() => {
    const { cinema, gym, courses, pharma, travel, restaurant } = values;
    const saveCinema = cinema * 17;
    const saveGym = (gym * 25) / 100;
    const saveCourses = (courses * 25) / 100;
    const savePharma = (pharma * 20) / 100;
    const saveTravel = (travel * 20) / 100;
    const saveRestaurant = (restaurant * 10) / 100;
    const newValue = saveCinema + saveGym + saveCourses + savePharma + saveTravel + saveRestaurant;

    setCostSaved(String(Math.trunc(newValue)));
  }, [values]);

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { name, value, max } = event.target;
      const percentage = `${((Number(value) / Number(max)) * 100).toString()}%`;
      setValues({ ...values, [name]: value, [`${name}PerCent`]: percentage });
    },
    [costSaved],
  );

  return (
    <Container>
      <section className="simulator-section colab-toggleAnimate--js">
        <div className="simulator-wrapper">
          <div className="simulator-content content flex">
            <div className="content-text-rigth">
              <h2>Calcule quanto você pode <b>economizar</b></h2>
            </div>

            <div className="content flex wrapper-form">
              <div className="form-calc">
                <form className="form-caulate-discount">
                  <p>{data.subtitle}</p>
                  <div className="input-range-wrapper">
                    <label>Ingressos de cinema</label>
                    <input
                      name="cinema"
                      type="range"
                      className="cinema"
                      min="0"
                      max="20"
                      value={values.cinema}
                      onChange={handleInputChange}
                      style={{ backgroundSize: `${values.cinemaPerCent} 100%` }}
                    />
                    <div className="value-discount">
                      <input
                        name="cinema"
                        type="number"
                        className="cinema input-center"
                        min="0"
                        max="20"
                        value={values.cinema}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-range-wrapper sifra-mini">
                    <label>Mensalidade da academia</label>
                    <input
                      name="gym"
                      type="range"
                      className="gym"
                      min="0"
                      max="2000"
                      value={values.gym}
                      onChange={handleInputChange}
                      style={{ backgroundSize: `${values.gymPerCent} 100%` }}
                    />
                    <div className="value-discount">
                      <span>R$</span>
                      <input
                        name="gym"
                        type="number"
                        className="gym"
                        min="0"
                        max="2000"
                        value={values.gym}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-range-wrapper sifra-mini">
                    <label>Mensalidade de cursos que você faz</label>
                    <input
                      name="courses"
                      type="range"
                      className="online"
                      min="0"
                      max="5000"
                      value={values.courses}
                      onChange={handleInputChange}
                      style={{ backgroundSize: `${values.coursesPerCent} 100%` }}
                    />
                    <div className="value-discount">
                      <span>R$</span>
                      <input
                        name="courses"
                        type="number"
                        className="online"
                        min="0"
                        max="5000"
                        value={values.courses}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-range-wrapper sifra-mini">
                    <label>Medicamentos para você e sua família</label>
                    <input
                      name="pharma"
                      type="range"
                      className="farmacias"
                      min="0"
                      max="2000"
                      value={values.pharma}
                      onChange={handleInputChange}
                      style={{ backgroundSize: `${values.pharmaPerCent} 100%` }}
                    />
                    <div className="value-discount">
                      <span>R$</span>
                      <input
                        name="pharma"
                        type="number"
                        className="farmacias"
                        min="0"
                        max="2000"
                        value={values.pharma}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-range-wrapper sifra-mini">
                    <label>Viagens e Entretenimento</label>
                    <input
                      name="travel"
                      type="range"
                      className="travels"
                      min="0"
                      max="8000"
                      value={values.travel}
                      onChange={handleInputChange}
                      style={{ backgroundSize: `${values.travelPerCent} 100%` }}
                    />
                    <div className="value-discount">
                      <span>R$</span>
                      <input
                        name="travel"
                        type="number"
                        className="travels"
                        min="0"
                        max="8000"
                        value={values.travel}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-range-wrapper sifra-mini">
                    <label>Restaurantes</label>
                    <input
                      name="restaurant"
                      type="range"
                      className="restaurant"
                      min="0"
                      max="2000"
                      value={values.restaurant}
                      onChange={handleInputChange}
                      style={{ backgroundSize: `${values.restaurantPerCent} 100%` }}
                    />
                    <div className="value-discount">
                      <span>R$</span>
                      <input
                        name="restaurant"
                        type="number"
                        className="restaurant"
                        min="0"
                        max="2000"
                        value={values.restaurant}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </form>
              </div>

              <div className="total-calc">
                <BgImage image="img/calc-bg.svg" left="0px" bottom="0px" width={120} height={30} />
                <BgImage image="img/calc-bg.svg" right="0px" top="0px" width={120} height={30} />
                <BgImage image="img/calc-bg4.svg" right={30} top={-40} width={40} height={40} />
                <BgImage image="img/calc-bg2.svg" left={-40} top={80} width={120} height={30} />
                <BgImage image="img/calc-bg3.svg" bottom={100} right="0px" width={60} height={34} />

                <div className="phone-row">
                  <p>{data.mobileText}</p>
                  <p className="money-calculated">R$ {costSaved}</p>
                </div>
              </div>
            </div>
            <div className="total-calc-mobile">
              <p>{data.mobileText}</p>
              <p className="money-calculated">R$ {costSaved}</p>
            </div>
          </div>
          <Link to="/register">
            <Button title={data.buttonText} classType="main-button fat center blue hide-on-mobile" />
          </Link>
        </div>
      </section>
    </Container>
  );
};

export default CalculatorSectionComponent;
